import { useMemo } from 'react';
import { createTheme, StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/public-sans/700.css';

import { roRO } from '@mui/x-data-grid/locales';
import { roRO as coreRoRO } from '@mui/material/locale';
import CustomShadows from './custom-shadows';
import componentsOverride from './overrides';
import { buildPalette } from './palette';
import Typography from './typography';

export default function ThemeCustomization({ children }) {
  const fontFamily = "'Public Sans', sans-serif";

  const themeTypography = useMemo(() => Typography(fontFamily), [fontFamily]);

  const palette = useMemo(() => buildPalette(), []);

  const themeOptions = useMemo(
    () => ({
      breakpoints: {
        values: {
          xs: 0,
          sm: 768,
          md: 1024,
          lg: 1266,
          xl: 1440
        }
      },
      direction: 'ltr',
      mixins: {
        toolbar: {
          minHeight: 60,
          paddingTop: 8,
          paddingBottom: 8
        }
      },
      typography: themeTypography,
      colorSchemes: {
        light: {
          palette: palette.light,
          customShadows: CustomShadows(palette.light)
        },
        dark: {
          palette: palette.dark,
          customShadows: CustomShadows(palette.dark)
        }
      },
      cssVariables: {
        cssVarPrefix: '',
        colorSchemeSelector: 'class'
      }
    }),
    [themeTypography, palette]
  );

  const themes = createTheme(themeOptions, roRO, coreRoRO);
  themes.components = { ...themes.components, ...componentsOverride(themes) };

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider disableTransitionOnChange theme={themes} modeStorageKey="appearance" defaultMode="light">
        <CssBaseline enableColorScheme />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
